import { useEffect, useState, useRef } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { IconHamberger, IconClose } from "../../Assets/Icons";
import { Link } from "react-router-dom";
const FaSearch = require("react-icons/fa").FaSearch;

interface UserProfile {
  id: number;
  name: string;
  email: string;
  no_tlpn: string | null;
}

interface Presiden {
  id: number;
  nama: string;
  jabatan: string;
  bidang: string;
  foto: string;
}

const Navbar: React.FC = () => {
  const [user, setUser] = useState<UserProfile | null>(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState<Presiden[]>([]);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  // 🔹 Fetch profile user
  useEffect(() => {
    const token = Cookies.get("token");
    if (!token) return;

    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/profile`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setUser(res.data))
      .catch((err) => console.error("Error fetch profile:", err));
  }, []);

  // 🔹 Handle logout
  const handleLogout = () => {
    Cookies.remove("token");
    Cookies.remove("refresh_token");
    window.location.href = "/loginuser";
  };

  // 🔹 Fetch search Presiden (dengan auth)
  const fetchPresiden = async (term = "") => {
    try {
      setLoadingSearch(true);
      const token = Cookies.get("token");
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/presiden`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { search: term || undefined },
      });
      setSearchResults(res.data.data.slice(0, 5)); // hanya ambil 5 data
    } catch (err) {
      console.error("Gagal fetch data presiden:", err);
    } finally {
      setLoadingSearch(false);
    }
  };

  useEffect(() => {
    if (searchOpen) {
      fetchPresiden(); // ambil default 5 data
      setSearchTerm("");
      setTimeout(() => {
        inputRef.current?.focus(); // arahkan kursor otomatis ke input
      }, 100); // kasih sedikit delay biar popup sempat muncul dulu
    }
  }, [searchOpen]);

  return (
    <header className="fixed top-0 left-0 w-full z-50 bg-white/30 backdrop-blur-md shadow-lg border-b border-white/20 px-4 py-3 flex max-sm:justify-between md:justify-end gap-4 items-center">
      {/* 🔍 Tombol Search */}
      <button
        onClick={() => setSearchOpen(true)}
        className="flex items-center justify-center sm:justify-start gap-3 w-10 sm:w-64 h-10 bg-transparent sm:bg-white sm:border sm:border-gray-300 rounded-full px-0 sm:px-4 py-2 sm:shadow-sm hover:bg-gray-100 sm:hover:bg-white hover:shadow-md hover:border-gray-400 transition-all duration-300 ease-in-out">
        <FaSearch className="text-gray-600 text-lg sm:text-base" />
        <span className="hidden sm:inline text-gray-500 text-sm">Search ...</span>
      </button>

      {/* 🍔 Tombol Menu */}
      <button onClick={() => setMenuOpen(true)} className="p-1">
        <IconHamberger />
      </button>

      {/* 🧭 Slide Menu dari kanan */}
      <div className={`fixed top-0 right-0 h-full w-1/2 max-w-sm bg-white  transform transition-transform duration-300 z-50 ${menuOpen ? "translate-x-0" : "translate-x-full"}`}>
        <div className="  h-full bg-white">
          {/* Header */}
          <div className="flex justify-between items-center  p-6">
            <h2 className="text-lg font-semibold">Profil</h2>
            <button onClick={() => setMenuOpen(false)} className="text-gray-600 hover:text-black">
              <IconClose />
            </button>
          </div>

          {/* User Info */}
          {user ? (
            <div className="space-y-2 border-b    bg-white -mt-5">
              <div className="p-6">
                <p className="font-semibold text-gray-800">{user.name}</p>
                <p className="text-gray-600 text-sm">{user.email}</p>
              </div>
            </div>
          ) : (
            <p className="text-gray-500">Memuat data pengguna...</p>
          )}

          {/* Logout */}
          <div className="mt-auto bg-white p-3">
            <button onClick={handleLogout} className="bg-red-500 text-white w-full py-2 rounded-lg font-semibold hover:bg-red-600 transition">
              Logout
            </button>
          </div>
        </div>
      </div>

      {/* 🔘 Overlay belakang menu */}
      {menuOpen && <div className="fixed inset-0 bg-black/40 z-40" onClick={() => setMenuOpen(false)}></div>}

      {/* 🔍 Popup Search */}
      {searchOpen && (
        <div className="fixed inset-0 flex justify-center items-start pt-20 z-50 h-full">
          <div className="bg-white rounded-lg w-[90%] max-w-lg p-6 shadow-lg relative">
            <button onClick={() => setSearchOpen(false)} className="absolute top-3 right-3 text-gray-600 hover:text-black">
              <IconClose />
            </button>
            <h3 className="text-lg font-bold mb-4">Cari Pejabat</h3>
            <input
              ref={inputRef}
              type="text"
              value={searchTerm}
              onChange={(e) => {
                const value = e.target.value;
                setSearchTerm(value);
                fetchPresiden(value);
              }}
              placeholder="Ketik nama pejabat..."
              className="border px-4 py-2 w-full rounded-lg focus:outline-none focus:ring focus:ring-primary"
            />

            {/* Hasil Pencarian */}
            <div className="mt-4 max-h-80 overflow-y-auto">
              {loadingSearch ? (
                <div className="flex justify-center items-center h-20">
                  <div className="animate-spin rounded-full h-8 w-8 border-t-4 border-primary"></div>
                </div>
              ) : searchResults.length > 0 ? (
                searchResults.map((p) => (
                  <Link key={p.id} to={`/detailPageUtama/${p.id}`}>
                    <div className="flex items-center gap-3 border-b py-2 cursor-pointer hover:bg-gray-100 rounded-md px-2">
                      <img src={p.foto} alt={p.nama} className="w-12 h-12 rounded-full object-cover" />
                      <div>
                        <p className="font-semibold text-sm">{p.nama}</p>
                        <p className="text-xs text-gray-600">{p.jabatan}</p>
                        <p className="text-xs text-gray-500 italic">{p.bidang}</p>
                      </div>
                    </div>
                  </Link>
                ))
              ) : searchTerm ? (
                <p className="text-gray-500 text-sm">Tidak ditemukan hasil.</p>
              ) : (
                <p className="text-gray-400 text-sm">Ketik untuk mencari...</p>
              )}
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
